/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

/* eslint-env browser */
module.exports = typeof self === 'object' ? self.FormData : window.FormData;




//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/browser.js
// module id = 1154
// module chunks = 60